import { Flex } from '@chakra-ui/react';
import { Text } from '@kula-ai/components';
import { File04, XClose } from '@kula-ai/icons-core';
import type { AttachmentChip } from './attachDocumentSelection';

export interface SelectedAttachmentChipsProps {
  chips?: AttachmentChip[];
  onRemove?: (_key: string) => void;
}

const REMOVE_LABEL = 'Remove attachment';

/**
 * The documents chosen for this email, shown below the composer.
 *
 * A chip is a *reference* to one of the candidate's documents — there is no file
 * here to preview or download, only the name of what will be attached when the
 * email goes out.
 */
export const SelectedAttachmentChips = ({
  chips = [],
  onRemove = () => {},
}: SelectedAttachmentChipsProps) => {
  if (!chips.length) return null;

  return (
    <Flex gap="6px" flexWrap="wrap" data-test-id="selected-attachment-chips">
      {chips.map((chip) => (
        <Flex
          key={chip.key}
          alignItems="center"
          gap="8px"
          px="8px"
          py="6px"
          border="1px solid"
          borderColor="border-color"
          borderRadius="6px"
          data-test-id={`attachment-chip-${chip.key}`}
        >
          <Flex
            alignItems="center"
            justifyContent="center"
            w="24px"
            h="24px"
            borderRadius="3px"
            bg="secondary-25"
          >
            <File04 size={14} />
          </Flex>
          <Text variant="p">{chip.name}</Text>
          <Flex
            as="button"
            type="button"
            alignItems="center"
            cursor="pointer"
            aria-label={`${REMOVE_LABEL}: ${chip.name}`}
            onClick={() => onRemove(chip.key)}
            data-test-id={`attachment-chip-remove-${chip.key}`}
          >
            <XClose size={14} />
          </Flex>
        </Flex>
      ))}
    </Flex>
  );
};
